<template>
  <div>
    <v-stepper v-model="customerAccountStepper">
      <v-stepper-header>
        <v-stepper-step step="1" :complete="customerAccountStepper > 1">1. Basic Info</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2" :complete="customerAccountStepper > 2">1. Address</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3" :complete="customerAccountStepper > 3">2. Contact</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="4">4. Confirmation</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-form v-model="valid1">
            <v-card color="grey lighten-4" class="mb-5">
              <v-card-text>
                <v-text-field
                  v-model="customerName"
                  label="Customer Name"
                  type="text"
                  hint="Please enter your customer name here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="phoneNumber"
                  label="Phone Number"
                  hint="Please enter your phone number here"
                  :counter="10"
                  maxlength="10"
                  :mask="phoneMask"
                  :rules="phoneRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="emailAddress"
                  label="Email1"
                  hint="Please enter customer email here"
                  :counter="45"
                  maxlength="45"
                  :rules="emailRules"
                  required
                  clearable
                ></v-text-field>
              </v-card-text>
            </v-card>
            <small>*indicates required field</small>
            <br>
            <div class="red--text" v-html="error"></div>
            <br>
            <v-btn color="primary" @click.native="customerAccountStepper = 2" :disabled="!valid1">Continue</v-btn>
            <v-btn flat @click.native="cancel">Cancel</v-btn>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-form v-model="valid2">
            <v-card color="grey lighten-4" class="mb-5">
              <v-card-text>
                <v-text-field
                  v-model="unitNumber"
                  label="Unit Number"
                  type="text"
                  hint="Please enter customer unit number here"
                  :counter="45"
                  maxlength="45"
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="streetAddress"
                  label="Street Address"
                  hint="Please enter customer street address here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  clearable
                  required
                ></v-text-field>
                <v-text-field
                  v-model="city"
                  label="City"
                  hint="Please enter customer city here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="province"
                  label="Province"
                  hint="Please enter customer province here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="postalCode"
                  label="Postal Code"
                  hint="Please enter customer postal code here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
              </v-card-text>
            </v-card>
            <small>*indicates required field</small>
            <br>
            <div class="red--text" v-html="error"></div>
            <br>
            <v-btn flat @click.native="customerAccountStepper = 1">Back</v-btn>
            <v-btn color="primary" @click.native="customerAccountStepper = 3" :disabled="!valid2">Continue</v-btn>
            <v-btn flat @click.native="cancel">Cancel</v-btn>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="3">
          <v-form v-model="valid3">
            <v-card color="grey lighten-4" class="mb-5">
              <v-card-text>
                <v-text-field
                  v-model="contactFirstName"
                  label="Customer Contact - First Name"
                  type="text"
                  hint="Please enter customer contact first name here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="contactLastName"
                  label="Customer Contact - Last Name"
                  hint="Please enter your emergency contact 1 last name here"
                  :counter="45"
                  maxlength="45"
                  :rules="nameRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="contactPhoneNumber"
                  label="Customer Contact - Phone Number"
                  hint="Please enter customer emergency contact phone number here"
                  :counter="10"
                  maxlength="10"
                  :mask="phoneMask"
                  :rules="phoneRules"
                  required
                  clearable
                ></v-text-field>
                <v-text-field
                  v-model="contactEmailAddress"
                  label="Customer Contact - Email"
                  hint="Please enter your customer contact 1 email here"
                  :counter="45"
                  maxlength="45"
                  :rules="emailRules"
                  required
                  clearable
                ></v-text-field>
              </v-card-text>
            </v-card>
            <small>*indicates required field</small>
            <br>
            <div class="red--text" v-html="error"></div>
            <br>
            <v-btn flat @click.native="customerAccountStepper = 2">Back</v-btn>
            <v-btn color="primary" @click.native="customerAccountStepper = 4" :disabled="!valid3">Continue</v-btn>
            <v-btn flat @click.native="cancel">Cancel</v-btn>
          </v-form>
        </v-stepper-content>

        <v-stepper-content step="4">
          <v-card color="grey lighten-4" class="mb-5"></v-card>
            <v-card-text class="text-xs-left">
              <p>Customer Name: {{this.customerName}} </p>
            </v-card-text>
            <br>
            <div class="red--text" v-html="error"></div>
            <br>
            <v-btn flat @click.native="customerAccountStepper = 3">Back</v-btn>
            <v-btn color="primary" @click.native="create">Submit</v-btn>
            <v-btn flat @click.native="cancel">Cancel</v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

  </div>
</template>
<script>
import customerAccountService from '@/services/CustomerAccountService'
  export default {
    data () {
      return {
        valid: false,
        valid1: false,
        valid2: false,
        valid3: false,

        phoneMask: 'phone',
        nameRules: [
          (v) => !!v || 'This field is required'
        ],
        phoneRules: [
          (v) => !!v || 'Phone is required',
          (v) => /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v) || 'Phone must be 10 digits'
        ],
        emailRules: [
          (v) => !!v || 'E-mail is required',
          (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ],
        customerAccountStepper: 0,
        customerName: '',
        phoneNumber: '',
        emailAddress: '',
        unitNumber: '',
        streetAddress: '',
        city: '',
        province: '',
        postalCode: '',
        contactFirstName: '',
        contactLastName: '',
        contactPhoneNumber: '',
        contactEmailAddress: '',
        error: null
      }
    },
    methods: {
      cancel() {
        this.$router.push({
          name: 'customerAccountList'
        })
      },
      async create() {
        try {
          const response = await customerAccountService.create({
            customerName: this.customerName.trim(),
            phoneNumber: this.phoneNumber.trim(),
            unitNumber: this.unitNumber.trim(),
            streetAddress: this.streetAddress.trim().toUpperCase(),
            city: this.city.trim().toUpperCase(),
            province: this.province.trim().toUpperCase(),
            postalCode: this.postalCode.trim().toUpperCase(),
            emailAddress: this.emailAddress.trim(),
            contactFirstName: this.contactFirstName.trim(),
            contactLastName: this.contactLastName.trim(),
            contactPhoneNumber: this.contactPhoneNumber.trim(),
            contactEmailAddress: this.contactEmailAddress.trim()
          })
          this.error = "Create Successful"
          this.$router.push({
            name: 'customerAccountList'
          })
        } catch (error) {
            this.error = this.handleError(error)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/CustomerAccount/CustomerAccountNew.vue